import DataHandler from "./DataHandler";
import FormArea from "./FormArea";

export class FormOwnCV extends DataHandler {
    constructor(props) {
        super(props);
        this.state = {
            hasData: false,
            Jobs: null,
            data: null,
            CustomGDPRText: null,
            PrivacyHint: null,
            EmailHint: null,
            jobs: null,
            locations: null,
            currentJob: null,
            errors: null,
            SendApplicationText: null,
            Countries: null,
            RedirectURL: null,
            ButtonDisabled: false,
        }
        this.submitApplication = this.submitApplication.bind(this);
        this.collectData = this.collectData.bind(this);
        this.getCountries = this.getCountries.bind(this);
        this.collectMultiSelectData = this.collectMultiSelectData.bind(this);
        this.renderFormAreas = this.renderFormAreas.bind(this);
        this.handleFormValidation = this.handleFormValidation.bind(this);
    }

    componentDidMount() {
        fetch(this.props.DataLink).then(response => {
            return response.json();
        }).then(json => {
            this.setState({
                hasData: true,
                PersonalDataText: json.PersonalDataText,
                CustomGDPRText: json.CustomGDPRText,
                PrivacyHint: json.PrivacyHint,
                EmailHint: json.EmailHint,
                jobs: json.AllJobs,
                locations: json.Locations,
                currentJob: json.CurrentJob,
                data: json.FormAreas,
                SendApplicationText: json.SendApplicationText,
                InitiativeApplicationTitle: json.InitiativeApplicationTitle,
                Countries: json.Countries,
                RedirectURL: json.RedirectURL,
            })
            this.trackInput('Init', 'Init', this.formType())
        })
    }

    getCountries() {
        if (this.state.Countries !== undefined) {
            return this.state.Countries;
        }
        return null;
    }

    renderRequiredHint() {
        if (this.props.RequiredFieldHint) {
            return (
                <div className="row">
                    <div className="col-12 col-lg-10 offset-lg-1">
                        <p>{this.props.RequiredFieldHint}</p>
                    </div>
                </div>
            )
        }
        return null;
    }


    submitApplication() {
        //Daten Fischen aus: this.state.data, this,state.jobs, this.state.FormAreas.FIELD.Items
    }


    renderFormAreas() {
        return this.state.data.map((area, index) => {
            return <FormArea
                key={index}
                Key={area.Key}
                Title={area.Title}
                SubTitle={area.SubTitle}
                IconClass={area.IconClass}
                Fields={area.Fields}
                HasBG={area.HasBG}
                HasPaddingBottom={area.HasPaddingBottom}
                Values={this.state.jobs}
                PreselectedValue={this.state.currentJob}
                InitiativeApplicationTitle={this.state.InitiativeApplicationTitle}
                SaveText={this.state.SaveText}
                CancelText={this.state.CancelText}
                collectMultiSelectData={this.collectMultiSelectData}
                collectData={this.collectData}
                trackInput={this.trackInput}
                Countries={this.getCountries}
            />
        })
    }

    handleForm() {
        this.trackSubmit();
        this.setState({
            ButtonDisabled: true,
        })
        this.handleFormValidation();
        setTimeout(() => {
            this.setState({
                ButtonDisabled: false,
            })
        }, 5000)
    }

    renderButton() {
        if (this.state.ButtonDisabled) {
            return (
                <button type="button" className="btn btn-primary" disabled>
                    <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                </button>
            )
        }
        return (
            <button type="button" className="btn btn-primary" onClick={(e) => {this.handleForm()}}>
                {this.state.SendApplicationText}
            </button>
        )
    }

    formType(){
        return 'OwnCV';
    };

    render() {
        if (!this.state.hasData) {
            return null;
        }
        return (
            <div>
                {this.renderToastMessage()}
                <form>
                    <fieldset>
                    {this.renderFormAreas()}
                    </fieldset>
                </form>
                {this.renderRequiredHint()}
                <div className="row">
                    <div className="col-12 col-lg-10 offset-lg-1">
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        )
    }
}

export default FormOwnCV;
